"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Edge = void 0;
/**
 * Represents graph information
 */
var Edge = /** @class */ (function (_super) {
    __extends(Edge, _super);
    function Edge() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "Edge";
        _this.source = function () {
            _this.push(function (_) { return "source"; });
        };
        _this.target = function () {
            _this.push(function (_) { return "target"; });
        };
        _this.edgeId = function () {
            _this.push(function (_) { return "edgeId"; });
        };
        _this.type = function () {
            _this.push(function (_) { return "type"; });
        };
        _this.weight = function () {
            _this.push(function (_) { return "weight"; });
        };
        _this.properties = function () {
            _this.push(function (_) { return "properties"; });
        };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return Edge;
}(Array));
exports.Edge = Edge;
//# sourceMappingURL=Edge.js.map